import { render, staticRenderFns } from "./cooprationInfo.vue?vue&type=template&id=78385f35&scoped=true"
import script from "./cooprationInfo.vue?vue&type=script&lang=js"
export * from "./cooprationInfo.vue?vue&type=script&lang=js"
import style0 from "./cooprationInfo.vue?vue&type=style&index=0&id=78385f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78385f35",
  null
  
)

export default component.exports